<h1 class="matp-page-title">デバイス設定一覧</h1>

<!-- タブ切替 -->
@if (role === "tenant_admin") {
  <div class="tw-my-2">
    <mat-button-toggle-group
      class="matp-button-toggle-group matp-button-inactive"
      aria-label="表示種類"
      [hideSingleSelectionIndicator]="'true'"
      [(ngModel)]="selectedDisplayType"
    >
      <mat-button-toggle class="tw-w-40" value="list">
        デバイス一覧
      </mat-button-toggle>
      <mat-button-toggle class="tw-w-40" value="groupSetting">
        設定グループ一覧
      </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
}

<!-- デバイス設定一覧 -->
<mat-card class="matp-card">
  <app-device-setting-list-table
    [deviceSettingList]="deviceSettingList"
    [deviceSetting]=""
    [role]="role"
    [assettypeList]="assettypeList"
    [currentTenant]="currentTenant"
    [deviceTypeDisplayNames]="deviceTypeDisplayNames"
    [selection]="selection"
    *ngIf="selectedDisplayType === 'list'"
    (updated)="openDeviceSettingDetailEditDialog($event)"
    (updatedName)="updateDeviceName($event)"
    (updatedTag)="openDeviceTagEditDialog($event)"
  >
  </app-device-setting-list-table>
  <app-device-group-list-table
    [deviceSettingGroupList]="deviceSettingGroupList"
    [deviceSetting]=""
    [role]="role"
    [assettypeList]="assettypeList"
    [currentTenant]="currentTenant"
    [groupDeviceTypeDisplayNames]="groupDeviceTypeDisplayNames"
    *ngIf="selectedDisplayType === 'groupSetting'"
    (updatedGroupDetail)="
      openDeviceGroupSettingDetailEditDialog(
        $event.deviceSettingGroupId,
        $event.deviceTypeKey
      )
    "
    (updatedGroup)="openDeviceSettingGroupEditDialog($event)"
    (deletedGroup)="deleteDeviceSettingGroup($event)"
    (openBulkSettingErrorDialog)="openBulkSettingErrorDialog($event)"
  >
  </app-device-group-list-table>
</mat-card>
